import React, { useRef } from 'react';
import {Tag as BTag, Link as BLink} from "@bedrock/components";
import './index.less';
import BlockTitle from '../BlockTitle';
import BaseInfoForm from '../BaseInfoForm';
import TenderForm from '../TenderForm';
import DetailLayoutWithTabs from '../DetailLayoutWithTabs';
import EvaluationForm from '../EvaluationForm';
import { useBidingHistoryModal } from "@mpc/common/src/features/HistoryQuoteModal/bc";
import { NodeEnum } from 'containers/OutBidding/utils';

const Template = (props: any) => {
  const { detail = {}, editFields = [], renderOpers, hasSubmitted } = props;
  const baseFormRef: any = useRef();
  const tenderFormRef: any = useRef();
  const evaluationFormRef: any = useRef();

  const prefixClx = 'bidding-detail-all';
  const baseInfoFormProps = {
    detail,
    editFields,
    ref: baseFormRef,
  };
  const tenderFormProps = {
    detail,
    editFields,
    ref: tenderFormRef,
  };
  const evaluationFormProps = {
    detail,
    editFields,
    ref: evaluationFormRef,
  };

  const renderTipTag = () => {
    if (typeof hasSubmitted !== 'boolean' || detail?.state !== NodeEnum.AWAITING_SUBMISSION_BIDS) {
      return null;
    }
    return hasSubmitted ? <BTag
      color='light-green'
      text="已提交"
      size='xSmall'
      style={{ marginLeft: 6 }}
    /> : <BTag
      color='light-orange'
      text="待提交"
      size='xSmall'
      style={{ marginLeft: 6 }}
    />
  }

  const validData = () => {
    if (baseFormRef.current && tenderFormRef.current) {
      const baseFormValues = baseFormRef.current.validData();
      const tenderFormValues = tenderFormRef.current.validData();
      const evaluationValues = evaluationFormRef.current.validData();
      if (baseFormValues && tenderFormValues && evaluationValues) {
        return {
          baseFormValues,
          tenderFormValues,
          evaluationValues,
        };
      }
    }
    return false;
  };

  const openBidingHistory = useBidingHistoryModal({
    isInner: false,
  });

  let opers = null;
  if (renderOpers) {
    opers = renderOpers(validData);
  }

  const showTurn = detail.turns_number > 1;

  return (
    <div className={prefixClx}>
      <DetailLayoutWithTabs detail={detail} opers={opers}>
        <BlockTitle style={{ marginTop: 20 }}>基本信息</BlockTitle>
        <div style={{ padding: 20, paddingTop: 4 }}>
          <BaseInfoForm {...baseInfoFormProps} />
        </div>
        <BlockTitle style={{ marginTop: 20 }}>
          方案提交
          {renderTipTag()}
          {
            showTurn && (<>
              <BTag
                border={true}
                color={'light-brand'}
                style={{ marginLeft: 6 }}
                text={`${detail.turns_number} 轮`}
              />
              <BLink style={{ marginLeft: 16 }} type={'primary'} onClick={(e) => {
                openBidingHistory({
                  biddingId: detail.id,
                  supplierId: detail.current_supplier_id,
                  supplierName: '',
                })
                e.preventDefault()
              }}>
                查看历史报价轮次
              </BLink>
            </>)
          }
        </BlockTitle>
        <div style={{ padding: 20, paddingTop: 4 }}>
          <EvaluationForm {...evaluationFormProps} />
        </div>
        <BlockTitle style={{ marginTop: 20 }}>比选信息</BlockTitle>
        <div style={{ padding: 20, paddingTop: 4 }}>
          <TenderForm {...tenderFormProps} />
        </div>
      </DetailLayoutWithTabs>
    </div>
  );
};

export default Template;
